import PropTypes from 'prop-types';
import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

// Import Routes
import { userRoutes, authRoutes } from './routes/allRoutes';

// Import middleware
import Authmiddleware from './routes/middleware/Authmiddleware';

// Layouts
import VerticalLayout from './components/VerticalLayout/';
import HorizontalLayout from './components/HorizontalLayout/';
import NonAuthLayout from './components/NonAuthLayout';

// Styles
import './assets/scss/theme.scss';

// Fake backend for testing
import api from './utils/api';
import BlockedIp from './pages/BlockedIp';
import fakeBackend from './helpers/AuthType/fakeBackend';
fakeBackend();

const IpGate = ({ children }) => {
  const location = useLocation();
  const [state, setState] = React.useState({ loading: true, allowed: true, ip: null });
  const [checkDone, setCheckDone] = React.useState(false);

  React.useEffect(() => {
    // ✅ Skip IP check if already on blocked page (prevent infinite loop)
    if (location.pathname === '/blocked') {
      setState({ loading: false, allowed: false, ip: null });
      setCheckDone(true);
      return;
    }

    // Prevent multiple checks
    if (checkDone) return;
    
    let cancelled = false;
    
    api.get('/ip-check')
      .then((res) => {
        if (!cancelled) {
          setState({ loading: false, allowed: true, ip: res.data?.ip });
          setCheckDone(true);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          const ip = err?.response?.data?.ip;
          setState({ loading: false, allowed: false, ip });
          setCheckDone(true);
        }
      });
    
    return () => { 
      cancelled = true; 
    };
  }, [checkDone, location.pathname]); // Re-check if location changes

  if (state.loading) return null; // or a spinner
  if (!state.allowed) return <BlockedIp ip={state.ip} />;
  return children;
};

const App = (props) => {
  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case 'horizontal':
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();

  return (
    <React.Fragment>
      <IpGate>
        <Routes>
          {/* Non-authenticated routes */}
          {authRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            />
          ))}

          {/* Authenticated routes */}
          {userRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
            />
          ))}
        </Routes>
      </IpGate>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
